// Helper: Test > Check if user is company tester
function checkIfUserIsCompanyTester (email) {
	return email.endsWith('@aixplain.com')
}

// Export
export {
	checkIfUserIsCompanyTester
}
